exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pageAdmin-body {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  position: fixed;\n  top: 0;\n  left: 0;\n  margin: 0;\n  background-color: white;\n  justify-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  -webkit-transition: .7s ease-in-out;\n  -o-transition: .7s ease-in-out;\n  transition: .7s ease-in-out; }\n\n.pageAdmin-mainField {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  justify-self: center !important;\n  -ms-flex-item-align: center !important;\n  align-self: center !important; }\n\n.MailForgotPass {\n  margin-top: 80px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/LoginAdmin/styles.scss
// module id = 1641
// module chunks = 0